import React, { FC, ReactNode } from 'react'

import { useTooltip } from 'hooks/useTooltip'

import { TooltipWithPinBase } from './TooltipWithPinBase'
import { TooltipBaseProps } from './types'

export const PopOverWithPin: FC<
  TooltipBaseProps & {
    enabled?: boolean
    name: string
    renderContent: ({ isOpen, toggleIsOpen }) => ReactNode
  }
> = ({ enabled, name, renderContent, children, ...rest }) => {
  const [isOpen, toggleIsOpen] = useTooltip(name)

  return (
    <TooltipWithPinBase
      {...rest}
      show={Boolean(isOpen)}
      content={renderContent({ isOpen, toggleIsOpen })}
    >
      <div onClick={enabled ? toggleIsOpen : undefined}>{children}</div>
    </TooltipWithPinBase>
  )
}
